/** 手順としてのティア算出（式・並べ替え・人数割合） */
export function TierCalculationHow() {
  return (
    <div className="win-rate-pick-scatter__panel">
      <h3 className="win-rate-pick-scatter__panel-title">ティアの出し方</h3>
      <ol className="win-rate-pick-scatter__steps">
        <li>
          各ヒーローについて<strong>ティアスコア</strong>を次の式で求めます。
          <div
            className="win-rate-pick-scatter__formula-display"
            role="math"
            aria-label="ティアスコアは勝率（パーセント）にベータ倍のバンピック率（パーセント）を足した値"
          >
            <p className="win-rate-pick-scatter__formula">
              ティアスコア ＝ 勝率（%）＋ β × バンピック率（%）
            </p>
          </div>
          <p className="win-rate-pick-scatter__formula-note">
            バンピック率は、ツールチップのピック率・BAN 率の表示を足した値（散布図の横軸と同じ換算）です。
          </p>
        </li>
        <li>
          スコアの<strong>高い順</strong>に並べ替えます。
        </li>
        <li>
          上位から<strong>人数割合</strong>で S / A / B / C / D に振り分けます（おおよそ 10%・10%・20%・30%・残り）。
        </li>
      </ol>
    </div>
  );
}
